import AgentList from './AgentList.jsx'

export default AgentList
